import { render, staticRenderFns } from "./personList.vue?vue&type=template&id=dad05bb2&scoped=true"
import script from "./personList.vue?vue&type=script&lang=js"
export * from "./personList.vue?vue&type=script&lang=js"
import style0 from "./personList.vue?vue&type=style&index=0&id=dad05bb2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad05bb2",
  null
  
)

export default component.exports